{
    "en": {
        "1": "Outside opening hours.",
        "2": "Object is not available on Sundays.",
        "3": "Object is not available on Mondays.",
        "4": "Object is not available on Tuesdays.",
        "5": "Object is not available on Wednesdays.",
        "6": "Object is not available on Thursdays.",
        "7": "Object is not available on Fridays.",
        "8": "Object is not available on Saturdays.",
        "9": "Object is not available on specified time range.",
        "10": "Setup time before stored booking.",
        "11": "An existing booking.",
        "12": "Past.",
        "13": "Room is blocked for setup time before booking.",
        "14": "Outside earliest booking offset.",
        "15": "Outside latest booking offset.",
        "16": "Setup time after stored booking.",
        "17": "Room is blocked for setup time after booking.",
        "18": "Object has static user.",
        "20": "Temporary blocked by other user.",
        "21": "In holiday time.",
        "22": "Booking time to short.",
        "23": "Booking time to long.",
        "24": "Globally blocked by system.",
        "25": "Exceeded maximum of concurrent allowed bookings.",
        "26": "Exceeded maximum of allowed bookings for requested object.",
        "27": "Exceeded maximum of consequent booking days.",
        "28": "Exceeded maximum of consequent booking days for a given object category.",
        "29": "Object is never available.",
        "30": "Object is deactivated.",
        "31": "Exceeded maximum of daily allowed object bookings.",
        "32": "Exceeded maximum of daily allowed user bookings."
    },
    "de": {
        "1": "Außerhalb der Öffnungszeiten.",
        "2": "Das Objekt ist sonntags nicht verfügbar.",
        "3": "Das Objekt ist montags nicht verfügbar.",
        "4": "Das Objekt ist dienstags nicht verfügbar.",
        "5": "Das Objekt ist mittwochs nicht verfügbar.",
        "6": "Das Objekt ist donnerstags nicht verfügbar.",
        "7": "Das Objekt ist freitags nicht verfügbar.",
        "8": "Das Objekt ist samstags nicht verfügbar.",
        "9": "Das Objekt ist im angegebenen Zeitbereich nicht verfügbar.",
        "10": "Einrichtungszeit vor der gespeicherten Buchung.",
        "11": "Eine bestehende Buchung.",
        "12": "Vergangenheit.",
        "13": "Der Raum ist für die Nutzung vor der Buchung gesperrt.",
        "14": "Außerhalb des frühesten Buchungsversatzes.",
        "15": "Außerhalb des letzten Buchungsversatzes.",
        "16": "Aufbauzeit nach hinterlegter Buchung.",
        "17": "Der Raum ist nach der Buchung für die Aufbauzeit gesperrt.",
        "18": "Das Objekt hat einen statischen Benutzer.",
        "20": "Vorübergehend von einem anderen Benutzer blockiert.",
        "21": "In der Ferienzeit.",
        "22": "Buchungszeit zu kurz.",
        "23": "Buchungszeit zu lang.",
        "24": "Weltweit vom System blockiert.",
        "25": "Die maximale Anzahl gleichzeitig zulässiger Buchungen wurde überschritten.",
        "26": "Die maximale Anzahl zulässiger Buchungen für das angeforderte Objekt wurde überschritten.",
        "27": "Maximale Anzahl aufeinanderfolgender Buchungstage überschritten.",
        "28": "Die maximale Anzahl aufeinanderfolgender Buchungstage für eine bestimmte Objektkategorie wurde überschritten.",
        "29": "Objekt ist nie verfügbar.",
        "30": "Objekt ist deaktiviert.",
        "31": "Die maximale Anzahl zulässiger Objektbuchungen pro Tag wurde überschritten.",
        "32": "Das Maximum der täglich zulässigen Benutzerbuchungen wurde überschritten."
    },
    "sv": {
        "1": "Outside opening hours.",
        "2": "Object is not available on Sundays.",
        "3": "Object is not available on Mondays.",
        "4": "Object is not available on Tuesdays.",
        "5": "Object is not available on Wednesdays.",
        "6": "Object is not available on Thursdays.",
        "7": "Object is not available on Fridays.",
        "8": "Object is not available on Saturdays.",
        "9": "Object is not available on specified time range.",
        "10": "Setup time before stored booking.",
        "11": "An existing booking.",
        "12": "Past.",
        "13": "Room is blocked for setup time before booking.",
        "14": "Outside earliest booking offset.",
        "15": "Outside latest booking offset.",
        "16": "Setup time after stored booking.",
        "17": "Room is blocked for setup time after booking.",
        "18": "Object has static user.",
        "20": "Temporary blocked by other user.",
        "21": "In holiday time.",
        "22": "Booking time to short.",
        "23": "Booking time to long.",
        "24": "Globally blocked by system.",
        "25": "Exceeded maximum of concurrent allowed bookings.",
        "26": "Exceeded maximum of allowed bookings for requested object.",
        "27": "Exceeded maximum of consequent booking days.",
        "28": "Exceeded maximum of consequent booking days for a given object category.",
        "29": "Object is never available.",
        "30": "Object is deactivated.",
        "31": "Exceeded maximum of daily allowed object bookings.",
        "32": "Exceeded maximum of daily allowed user bookings."
    },
    "ro": {
        "1": "În afara orelor de program.",
        "2": "Obiectul nu este disponibil duminica.",
        "3": "Obiectul nu este disponibil luni.",
        "4": "Obiectul nu este disponibil marți.",
        "5": "Obiectul nu este disponibil miercuri.",
        "6": "Obiectul nu este disponibil joi.",
        "7": "Obiectul nu este disponibil vineri.",
        "8": "Obiectul nu este disponibil sâmbăta.",
        "9": "Obiectul nu este disponibil în intervalul de timp specificat.",
        "10": "Timp de pregătire înainte de rezervarea salvată.",
        "11": "Există deja o rezervare.",
        "12": "Trecut.",
        "13": "Camera este blocată pentru activități de pregătire înainte de rezervare.",
        "14": "În afara intervalului minim de rezervare.",
        "15": "În afara intervalului maxim de rezervare.",
        "16": "Timp de pregătire după rezervarea salvată.",
        "17": "Camera este blocată pentru timpul de pregătire după rezervare.",
        "18": "Obiectul are un utilizator static.",
        "20": "Blocat temporar de un alt utilizator.",
        "21": "În perioada de concediu.",
        "22": "Durata rezervării este prea scurtă.",
        "23": "Durata rezervării este prea lungă.",
        "24": "Blocat global de sistem.",
        "25": "S-a depășit numărul maxim de rezervări simultane permise.",
        "26": "S-a depășit numărul maxim de rezervări permise pentru obiectul solicitat.",
        "27": "S-a depășit numărul maxim de zile consecutive de rezervare.",
        "28": "S-a depășit numărul maxim de zile consecutive de rezervare pentru o anumită categorie de obiecte.",
        "29": "Obiectul nu este niciodată disponibil.",
        "30": "Obiectul este dezactivat.",
        "31": "S-a depășit numărul maxim zilnic de rezervări permise pentru obiect.",
        "32": "S-a depășit numărul maxim zilnic de rezervări permise pentru utilizator."
    },
    "pl": {
        "1": "Poza godzinami otwarcia.",
        "2": "Obiekt nie jest dostępny w niedziele.",
        "3": "Obiekt nie jest dostępny w poniedziałki.",
        "4": "Obiekt nie jest dostępny we wtorki.",
        "5": "Obiekt nie jest dostępny w środy.",
        "6": "Obiekt nie jest dostępny w czwartki.",
        "7": "Obiekt nie jest dostępny w piątki.",
        "8": "Obiekt nie jest dostępny w soboty.",
        "9": "Obiekt nie jest dostępny w określonym przedziale czasowym.",
        "10": "Czas przygotowania przed zarezerwowanym terminem.",
        "11": "Istniejąca rezerwacja.",
        "12": "Przeszłość.",
        "13": "Pokój jest zablokowany na czas przygotowania przed rezerwacją.",
        "14": "Poza najwcześniejszym przesunięciem rezerwacji.",
        "15": "Poza najpóźniejszym przesunięciem rezerwacji.",
        "16": "Czas przygotowania po zarezerwowanym terminie.",
        "17": "Pokój jest zablokowany na czas przygotowania po rezerwacji.",
        "18": "Obiekt ma stałego użytkownika.",
        "20": "Tymczasowo zablokowany przez innego użytkownika.",
        "21": "W czasie wakacji.",
        "22": "Czas rezerwacji za krótki.",
        "23": "Czas rezerwacji za długi.",
        "24": "Globalnie zablokowany przez system.",
        "25": "Przekroczono maksymalną liczbę równoczesnych dozwolonych rezerwacji.",
        "26": "Przekroczono maksymalną liczbę dozwolonych rezerwacji dla żądanego obiektu.",
        "27": "Przekroczono maksymalną liczbę kolejnych dni rezerwacji.",
        "28": "Przekroczono maksymalną liczbę kolejnych dni rezerwacji dla danej kategorii obiektu.",
        "29": "Obiekt nigdy nie jest dostępny.",
        "30": "Obiekt jest dezaktywowany.",
        "31": "Przekroczono maksymalną liczbę dziennych dozwolonych rezerwacji obiektu.",
        "32": "Przekroczono maksymalną liczbę dziennych dozwolonych rezerwacji użytkownika."
    },
    "it": {
        "1": "Fuori orario di apertura.",
        "2": "L'oggetto non è disponibile la domenica.",
        "3": "L'oggetto non è disponibile il lunedì.",
        "4": "L'oggetto non è disponibile il martedì.",
        "5": "L'oggetto non è disponibile il mercoledì.",
        "6": "L'oggetto non è disponibile il giovedì.",
        "7": "L'oggetto non è disponibile il venerdì.",
        "8": "L'oggetto non è disponibile il sabato.",
        "9": "L'oggetto non è disponibile nell'intervallo di tempo specificato.",
        "10": "Tempo di preparazione prima della prenotazione memorizzata.",
        "11": "Una prenotazione esistente.",
        "12": "Passato.",
        "13": "La stanza è bloccata per il tempo di preparazione prima della prenotazione.",
        "14": "Fuori dal limite di prenotazione più precoce.",
        "15": "Fuori dal limite di prenotazione più tardivo.",
        "16": "Tempo di preparazione dopo la prenotazione memorizzata.",
        "17": "La stanza è bloccata per il tempo di preparazione dopo la prenotazione.",
        "18": "L'oggetto ha un utente statico.",
        "20": "Bloccato temporaneamente da un altro utente.",
        "21": "In periodo di vacanza.",
        "22": "Tempo di prenotazione troppo breve.",
        "23": "Tempo di prenotazione troppo lungo.",
        "24": "Bloccato globalmente dal sistema.",
        "25": "Superato il massimo di prenotazioni simultanee consentite.",
        "26": "Superato il massimo di prenotazioni consentite per l'oggetto richiesto.",
        "27": "Superato il massimo di giorni consecutivi di prenotazione.",
        "28": "Superato il massimo di giorni consecutivi di prenotazione per una data categoria di oggetti.",
        "29": "L'oggetto non è mai disponibile.",
        "30": "L'oggetto è disattivato.",
        "31": "Superato il massimo di prenotazioni giornaliere consentite per l'oggetto.",
        "32": "Superato il massimo di prenotazioni giornaliere consentite per l'utente."
    },
    "nl": {
        "1": "Buiten openingstijden.",
        "2": "Object is niet beschikbaar op zondagen.",
        "3": "Object is niet beschikbaar op maandagen.",
        "4": "Object is niet beschikbaar op dinsdagen.",
        "5": "Object is niet beschikbaar op woensdagen.",
        "6": "Object is niet beschikbaar op donderdagen.",
        "7": "Object is niet beschikbaar op vrijdagen.",
        "8": "Object is niet beschikbaar op zaterdagen.",
        "9": "Object is niet beschikbaar binnen het opgegeven tijdsbereik.",
        "10": "Insteltijd vóór opgeslagen boeking.",
        "11": "Een bestaande boeking.",
        "12": "Verleden.",
        "13": "Kamer is geblokkeerd voor insteltijd vóór boeking.",
        "14": "Buiten vroegste boekingsoffset.",
        "15": "Buiten laatste boekingsoffset.",
        "16": "Insteltijd na opgeslagen boeking.",
        "17": "Kamer is geblokkeerd voor insteltijd na boeking.",
        "18": "Object heeft statische gebruiker.",
        "20": "Tijdelijk geblokkeerd door andere gebruiker.",
        "21": "In vakantietijd.",
        "22": "Boekingstijd te kort.",
        "23": "Boekingstijd te lang.",
        "24": "Globaal geblokkeerd door systeem.",
        "25": "Maximum aantal gelijktijdige toegestane boekingen overschreden.",
        "26": "Maximum aantal toegestane boekingen voor aangevraagd object overschreden.",
        "27": "Maximum aantal opeenvolgende boekingsdagen overschreden.",
        "28": "Maximum aantal opeenvolgende boekingsdagen voor een gegeven objectcategorie overschreden.",
        "29": "Object is nooit beschikbaar.",
        "30": "Object is gedeactiveerd.",
        "31": "Maximum aantal dagelijkse toegestane objectboekingen overschreden.",
        "32": "Maximum aantal dagelijkse toegestane gebruikersboekingen overschreden."
    },
    "hu": {
        "1": "Nyitvatartási időn kívül.",
        "2": "Az objektum vasárnap nem elérhető.",
        "3": "Az objektum hétfőn nem elérhető.",
        "4": "Az objektum kedden nem elérhető.",
        "5": "Az objektum szerdán nem elérhető.",
        "6": "Az objektum csütörtökön nem elérhető.",
        "7": "Az objektum pénteken nem elérhető.",
        "8": "Az objektum szombaton nem elérhető.",
        "9": "Az objektum a megadott időtartományban nem elérhető.",
        "10": "Beállítási idő a tárolt foglalás előtt.",
        "11": "Egy meglévő foglalás.",
        "12": "Múlt.",
        "13": "A szoba blokkolva van a foglalás előtti beállítási időre.",
        "14": "A legkorábbi foglalási eltoláson kívül.",
        "15": "A legkésőbbi foglalási eltoláson kívül.",
        "16": "Beállítási idő a tárolt foglalás után.",
        "17": "A szoba blokkolva van a foglalás utáni beállítási időre.",
        "18": "Az objektumnak statikus felhasználója van.",
        "20": "Ideiglenesen blokkolva más felhasználó által.",
        "21": "Ünnepi időszakban.",
        "22": "A foglalási idő túl rövid.",
        "23": "A foglalási idő túl hosszú.",
        "24": "Globálisan blokkolva a rendszer által.",
        "25": "Túllépte az engedélyezett egyidejű foglalások maximális számát.",
        "26": "Túllépte az engedélyezett foglalások maximális számát a kért objektumra.",
        "27": "Túllépte az egymást követő foglalási napok maximális számát.",
        "28": "Túllépte az egymást követő foglalási napok maximális számát egy adott objektumkategóriára.",
        "29": "Az objektum soha nem elérhető.",
        "30": "Az objektum deaktiválva van.",
        "31": "Túllépte a napi engedélyezett objektumfoglalások maximális számát.",
        "32": "Túllépte a napi engedélyezett felhasználói foglalások maximális számát."
    },
    "cz": {
        "1": "Mimo otevírací hodiny.",
        "2": "Objekt není k dispozici v neděli.",
        "3": "Objekt není k dispozici v pondělí.",
        "4": "Objekt není k dispozici v úterý.",
        "5": "Objekt není k dispozici ve středu.",
        "6": "Objekt není k dispozici ve čtvrtek.",
        "7": "Objekt není k dispozici v pátek.",
        "8": "Objekt není k dispozici v sobotu.",
        "9": "Objekt není k dispozici v zadaném časovém rozmezí.",
        "10": "Čas na přípravu před uloženou rezervací.",
        "11": "Existující rezervace.",
        "12": "Minulost.",
        "13": "Místnost je blokována pro čas na přípravu před rezervací.",
        "14": "Mimo nejčasnější časový posun rezervace.",
        "15": "Mimo nejpozdější časový posun rezervace.",
        "16": "Čas na přípravu po uložené rezervaci.",
        "17": "Místnost je blokována pro čas na přípravu po rezervaci.",
        "18": "Objekt má statického uživatele.",
        "20": "Dočasně blokováno jiným uživatelem.",
        "21": "V době dovolené.",
        "22": "Čas rezervace je příliš krátký.",
        "23": "Čas rezervace je příliš dlouhý.",
        "24": "Globálně blokováno systémem.",
        "25": "Překročen maximální počet současně povolených rezervací.",
        "26": "Překročen maximální počet povolených rezervací pro požadovaný objekt.",
        "27": "Překročen maximální počet po sobě jdoucích dnů rezervace.",
        "28": "Překročen maximální počet po sobě jdoucích dnů rezervace pro danou kategorii objektu.",
        "29": "Objekt není nikdy k dispozici.",
        "30": "Objekt je deaktivován.",
        "31": "Překročen maximální počet denních povolených rezervací objektu.",
        "32": "Překročen maximální počet denních povolených rezervací uživatele."
    }
}
